import React, { FC } from 'react';

import Loading from '@eika-infrastruktur/ui-kort-laster';

import { useConfig } from '../../default-config';

interface StatusProps {
    onClick: () => void;
}

const multipleLinesText = (texts: string) => {
    const lines = texts.split('<br />');
    return lines.map((text, index) => {
        return index === 0 ? text : [<br key={Math.random()} />, text];
    });
};

export const StatusPending: FC = () => {
    const { texts } = useConfig();
    return (
        <div className="popover-container register-status">
            <Loading title={texts.pendingText} />
        </div>
    );
};

export const StatusError: FC<StatusProps> = (props: StatusProps) => {
    const { texts } = useConfig();
    return (
        <div className="popover-container register-status error">
            <div className="status-content">
                <i className="ikon-utropstegn-36" aria-hidden />
                <h2>{multipleLinesText(texts.registerErrorHeader)}</h2>
                <p>{multipleLinesText(texts.registerErrorText)}</p>
                <button type="button" className="btn btn-default" onClick={props.onClick}>
                    {texts.buttonTextOk}
                </button>
            </div>
        </div>
    );
};

export const StatusRegisterSuccess: FC<StatusProps> = (props: StatusProps) => {
    const { texts } = useConfig();
    return (
        <div className="popover-container register-status success">
            <div className="status-content">
                <i className="ikon-usp-checkmark-36" aria-hidden />
                <h2>{multipleLinesText(texts.registerSuccessHeader)}</h2>
                <p>{multipleLinesText(texts.registerSuccessText)}</p>
                <button type="button" className="btn btn-default" onClick={props.onClick}>
                    {texts.buttonTextOk}
                </button>
            </div>
        </div>
    );
};
